<template>
	<div class="passes-background" :data-event-type="event">
		<svg
			id="Layer_2"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 956 140"
		>
			<defs>
				<linearGradient
					id="passes-linear-gradient"
					x1="478"
					y1="70"
					x2="952"
					y2="70"
					gradientUnits="userSpaceOnUse"
				>
					<stop
						offset="0"
						:stop-color="skins.get(event)?.stopColor1"
					/>
					<stop
						offset="1"
						:stop-color="skins.get(event)?.stopColor2"
					/>
				</linearGradient>
				<linearGradient
					id="passes-linear-gradient-2"
					x1="4"
					y1="70"
					x2="478"
					y2="70"
					gradientUnits="userSpaceOnUse"
				>
					<stop
						offset="0"
						:stop-color="skins.get(event)?.stopColor3"
					/>
					<stop
						offset="1"
						:stop-color="skins.get(event)?.stopColor4"
					/>
				</linearGradient>
			</defs>
			<g id="passes-bg">
				<path
					id="fill-right"
					class="cls-3"
					d="M952,53.7v32.6c-1.32-.2-2.65-.3-4-.3-14.34,0-26,11.66-26,26,0,1.35.1,2.69.31,4h-396.97l-1.17,1.14c-12.41,12.16-28.81,18.86-46.16,18.86h-.01V4h.01c17.36,0,33.75,6.7,46.17,18.86l1.16,1.14h396.97c-.21,1.31-.31,2.65-.31,4,0,14.34,11.66,26,26,26,1.35,0,2.68-.1,4-.3Z"
				/>
				<path
					id="fill-left"
					class="cls-1"
					d="M478,4v132c-17.36,0-33.75-6.7-46.17-18.86l-1.16-1.14H33.69c.21-1.31.31-2.65.31-4,0-14.34-11.66-26-26-26-1.35,0-2.69.1-4,.31v-32.62c1.31.21,2.65.31,4,.31,14.34,0,26-11.66,26-26,0-1.35-.1-2.69-.31-4h396.98l1.16-1.14c12.42-12.16,28.8-18.86,46.17-18.86Z"
				/>
				<path
					class="cls-2"
					d="M32,28c0,13.23-10.77,24-24,24-2.05,0-4.06-.25-6-.76l-2-2.75c2.48.98,5.18,1.51,8,1.51,12.16,0,22-9.85,22-22,0-2.82-.53-5.52-1.51-8l2.75,2c.51,1.94.76,3.95.76,6Z"
				/>
				<polygon
					class="cls-2"
					points="429.85 22 31.24 22 28.49 20 429.03 20 429.85 22"
				/>
				<path
					class="cls-2"
					d="M526.98,20l-.82,2-.58-.57c-12.79-12.53-29.69-19.43-47.57-19.43s-34.79,6.9-47.58,19.43l-.58.57-.82-2c12.63-12.37,29.91-20,48.98-20s36.34,7.63,48.97,20Z"
				/>
				<polygon
					class="cls-2"
					points="927.51 20 924.76 22 526.16 22 526.98 20 927.51 20"
				/>
				<path
					class="cls-2"
					d="M956,48.5l-2,2.74c-1.95.51-3.96.76-6,.76-13.23,0-24-10.77-24-24,0-2.05.25-4.06.76-6l2.75-2c-.98,2.48-1.51,5.18-1.51,8,0,12.15,9.85,22,22,22,2.82,0,5.52-.53,8-1.5Z"
				/>
				<polygon
					class="cls-2"
					points="956 48.5 956 91.5 954 88.76 954 51.24 956 48.5"
				/>
				<polygon
					class="cls-4"
					points="927.51 120 526.97 120 526.16 118 924.76 118 927.51 120"
				/>
				<path
					class="cls-4"
					d="M956,91.5c-2.48-.97-5.18-1.5-8-1.5-12.15,0-22,9.85-22,22,0,2.82.53,5.52,1.51,8l-2.75-2c-.51-1.94-.76-3.95-.76-6,0-13.23,10.77-24,24-24,2.04,0,4.05.25,6,.76l2,2.74Z"
				/>
				<path
					class="cls-4"
					d="M526.97,120c-12.62,12.37-29.9,20-48.96,20s-36.35-7.63-48.97-20l.81-2,.58.57c12.8,12.53,29.69,19.43,47.58,19.43s34.77-6.9,47.56-19.43l.59-.57.81,2Z"
				/>
				<polygon
					class="cls-4"
					points="2 51.24 2 88.76 0 91.51 0 48.49 2 51.24"
				/>
				<path
					class="cls-4"
					d="M32,112c0,2.05-.25,4.06-.76,6l-2.75,2c.98-2.48,1.51-5.18,1.51-8,0-12.15-9.84-22-22-22-2.82,0-5.52.53-8,1.51l2-2.75c1.94-.51,3.95-.76,6-.76,13.23,0,24,10.77,24,24Z"
				/>
				<polygon
					class="cls-4"
					points="429.85 118 429.04 120 28.49 120 31.24 118 429.85 118"
				/>
				<polygon
					class="cls-4"
					points="430.67 24 33.69 24 31.24 22 429.85 22 430.67 24"
				/>
				<path
					class="cls-4"
					d="M34,28c0,14.34-11.66,26-26,26-1.35,0-2.69-.1-4-.31l-2-2.45c1.94.51,3.95.76,6,.76,13.23,0,24-10.77,24-24,0-2.05-.25-4.06-.76-6l2.45,2c.21,1.31.31,2.65.31,4Z"
				/>
				<path
					class="cls-2"
					d="M34,112c0,1.35-.1,2.69-.31,4l-2.45,2c.51-1.94.76-3.95.76-6,0-13.23-10.77-24-24-24-2.05,0-4.06.25-6,.76l2-2.45c1.31-.21,2.65-.31,4-.31,14.34,0,26,11.66,26,26Z"
				/>
				<path
					class="cls-4"
					d="M526.16,22l-.82,2-1.16-1.14c-12.42-12.16-28.81-18.86-46.17-18.86s-33.76,6.7-46.18,18.86l-1.16,1.14-.82-2,.58-.57c12.79-12.53,29.69-19.43,47.58-19.43s34.78,6.9,47.57,19.43l.58.57Z"
				/>
				<polygon
					class="cls-4"
					points="924.76 22 922.31 24 525.34 24 526.16 22 924.76 22"
				/>
				<polygon
					class="cls-2"
					points="4 53.69 4 86.31 2 88.76 2 51.24 4 53.69"
				/>
				<polygon
					class="cls-4"
					points="954 51.24 954 88.76 952 86.3 952 53.7 954 51.24"
				/>
				<path
					class="cls-2"
					d="M954,88.76c-1.95-.51-3.96-.76-6-.76-13.23,0-24,10.77-24,24,0,2.05.25,4.06.76,6l-2.45-2c-.21-1.31-.31-2.65-.31-4,0-14.34,11.66-26,26-26,1.35,0,2.68.1,4,.3l2,2.46Z"
				/>
				<polygon
					class="cls-2"
					points="430.67 116 429.85 118 31.24 118 33.69 116 430.67 116"
				/>
				<path
					class="cls-4"
					d="M954,51.24l-2,2.46c-1.32.2-2.65.3-4,.3-14.34,0-26-11.66-26-26,0-1.35.1-2.69.31-4l2.45-2c-.51,1.94-.76,3.95-.76,6,0,13.23,10.77,24,24,24,2.04,0,4.05-.25,6-.76Z"
				/>
				<path
					class="cls-2"
					d="M526.16,118l-.59.57c-12.79,12.53-29.68,19.43-47.56,19.43s-34.78-6.9-47.58-19.43l-.58-.57.82-2,1.16,1.14c12.42,12.16,28.82,18.86,46.18,18.86s33.75-6.7,46.16-18.86l1.17-1.14.82,2Z"
				/>
				<polygon
					class="cls-2"
					points="924.76 118 526.16 118 525.34 116 922.31 116 924.76 118"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts" setup>
import { EventCategory } from "@/types/ui";

interface Props {
	event: EventCategory;
}

const { event } = defineProps<Props>();

const skins = new Map<
	EventCategory,
	{
		stopColor1: string;
		stopColor2: string;
		stopColor3: string;
		stopColor4: string;
	}
>([
	[
		EventCategory.CHRISTMAS,
		// TODO spravne farby ked budu
		{
			stopColor1: "#382546",
			stopColor2: "#5b1680",
			stopColor3: "rgba(20, 33, 9, 1)",
			stopColor4: "rgba(20, 33, 9, 0.5)",
		},
	],
	[
		EventCategory.EASTER,
		{
			stopColor1: "#382546",
			stopColor2: "#5b1680",
			stopColor3: "rgba(20, 33, 9, 1)",
			stopColor4: "rgba(20, 33, 9, 0.5)",
		},
	],
	[
		EventCategory.FISHING,
		{
			stopColor1: "#382546",
			stopColor2: "#5b1680",
			stopColor3: "#072331",
			stopColor4: "rgba(7, 35, 49, 0.5)",
		},
	],
	[
		EventCategory.FIREFEST,
		{
			stopColor1: "#5b1680",
			stopColor2: "#5b1680",
			stopColor3: "#aa3313",
			stopColor4: "#5b1680",
		},
	],
	[
		EventCategory.HUNTING,
		{
			stopColor1: "#382546",
			stopColor2: "#5b1680",
			stopColor3: "rgba(6, 27, 2, 1)",
			stopColor4: "rgba(6, 27, 2, 0.5)",
		},
	],
	[
		EventCategory.HALLOWEEN,
		{
			stopColor1: "#382546",
			stopColor2: "#5b1680",
			stopColor3: "rgba(16, 9, 33, 1)",
			stopColor4: "rgba(16, 9, 33, 0.5)",
		},
	],
]);
</script>

<style lang="scss" scoped>
.passes-background {
	display: flex;
	position: relative;
	z-index: 0;
	width: 100%;
	height: 3.5rem;

	svg {
		width: 100%;
		height: 100%;
	}

	.cls-1 {
		fill: url(#passes-linear-gradient-2);
	}
	.cls-2 {
		fill: #edd091;
	}
	.cls-3 {
		fill: url(#passes-linear-gradient);
	}
	.cls-4 {
		fill: #63451a;
	}
}
</style>
